(function () {
    var VISIBLE_SWATCHES = 5;
    var cachedAllProducts = null;

    function getRootPath() {
        var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
        if (!root) root = "/";
        if (root.charAt(0) !== "/") root = "/" + root;
        if (root.charAt(root.length - 1) !== "/") root += "/";
        return root;
    }

    function buildProductUrl(handle) {
        return getRootPath() + "products/" + handle;
    }

    function getCollectionContainers() {
        var all = document.querySelectorAll(".color-custom-rock");
        var collection = [];
        for (var i = 0; i < all.length; i++) {
            var el = all[i];
            if (el.closest && el.closest(".product-item-swatch-inner")) {
                collection.push(el);
            }
        }
        return collection;
    }

    function getProductPageContainer() {
        return document.getElementById("color-custom-rock");
    }

    function normalizeProduct(p) {
        return {
            title: p.title || "",
            handle: p.handle || "",
            featuredImage: p.featuredImage || (p.images && p.images[0] ? { url: p.images[0].src } : null),
        };
    }

    function fetchProductsJson(page, products) {
        page = page || 1;
        products = products || [];
        var url = getRootPath() + "products.json?limit=250&page=" + page;

        return fetch(url)
            .then(function (res) {
                if (!res.ok) throw new Error("products.json " + res.status);
                return res.json();
            })
            .then(function (json) {
                if (json.products && json.products.length) {
                    for (var i = 0; i < json.products.length; i++) {
                        products.push(normalizeProduct(json.products[i]));
                    }
                    if (json.products.length === 250) {
                        return fetchProductsJson(page + 1, products);
                    }
                }
                return products;
            });
    }

    function fetchAllProducts() {
        if (cachedAllProducts && cachedAllProducts.length) {
            return Promise.resolve(cachedAllProducts);
        }
        return fetchProductsJson(1, []).catch(function (err) {
            console.error("rt-color-swatches products.json error:", err);
            return [];
        });
    }

    var GENERIC_MODEL_TOKENS = {
        chubasquero: true,
        impermeable: true,
        reciclado: true,
        jacket: true,
        raincoat: true,
        product: true
    };

    function modelFromTitle(title) {
        return ((title || "").trim().split(/\s+/)[0] || "").toLowerCase();
    }

    function handleizeToken(value) {
        return (value || "")
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");
    }

    function handleHasModelToken(handle, model) {
        var token = handleizeToken(model);
        if (!token || token.length < 3 || GENERIC_MODEL_TOKENS[token]) return false;
        var parts = (handle || "").toLowerCase().split("-");
        return parts.indexOf(token) !== -1;
    }

    function matchedProducts(title, handle, allProducts) {
        var model = modelFromTitle(title);
        if (!model) return [];

        var seen = {};
        var result = [];
        for (var i = 0; i < allProducts.length; i++) {
            var p = allProducts[i];
            var sameTitleModel = modelFromTitle(p.title) === model;
            var sameHandleModel = handleHasModelToken(p.handle, model);
            if (!sameTitleModel && !sameHandleModel) continue;
            if (p.handle && !seen[p.handle]) {
                seen[p.handle] = true;
                result.push(p);
            }
        }
        return result;
    }

    function slugifyColor(title) {
        return (title || "").split(" ").slice(1).join("-").toLowerCase().replace(/[^a-z0-9-]/g, "-");
    }

    function colorLabel(title) {
        return (title || "").split(" ").slice(1).join(" ") || "";
    }

    function handleize(title) {
        return (title || "").toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");
    }

    function buildSwatchHtml(matched, currentHandle, isCollectionCard) {
        if (!matched.length) return "";

        var links = [];
        for (var i = 0; i < matched.length; i++) {
            var p = matched[i];
            var isActive = p.handle === currentHandle;
            var colorSlug = slugifyColor(p.title);
            var label = colorLabel(p.title);
            var imageUrl = (p.featuredImage && p.featuredImage.url) ? p.featuredImage.url : "";
            var newswatch = handleize(p.title);
            var isHidden = isCollectionCard && i >= VISIBLE_SWATCHES;
            var extraClass = isHidden ? " additional-swatch" : "";
            var style = isHidden ? ' style="display: none;"' : "";

            if (isCollectionCard) {
                links.push(
                    '<a href="' + buildProductUrl(p.handle) + '" data-newswatch="' + newswatch + '" data-images="' + imageUrl + '" class="zagocol opt-label tooltip' + (isActive ? " active" : "") + extraClass + '" data-swatch="' + colorSlug + '"' + style + '>' +
                    '<span class="tooltiptext">' + label + '</span></a>'
                );
            } else {
                links.push(
                    '<a href="' + buildProductUrl(p.handle) + '" class="opt-label tooltip' + (isActive ? " active" : "") + '" data-swatch="' + colorSlug + '">' +
                    '<span class="tooltiptext">' + label + '</span></a>'
                );
            }
        }

        var plusHtml = "";
        if (isCollectionCard && matched.length > VISIBLE_SWATCHES) {
            plusHtml = '<span class="plus-icon" role="button" tabindex="0" aria-label="Show more colors">+</span>';
        }

        return (
            (isCollectionCard ? "" : '<legend class="label">Color</legend>') +
            '<div class="option-selector__btns" data-firstswatch="' + currentHandle + '">' +
            links.join("") + plusHtml +
            "</div>"
        );
    }

    function countSwatchLinks(container) {
        var btns = container.querySelector(".option-selector__btns");
        if (!btns) return 0;
        return btns.querySelectorAll("a").length;
    }

    function displaySwatches(container, allProducts, isCollectionCard) {
        if (!container) return;

        var title = container.getAttribute("data-product-title");
        var handle = container.getAttribute("data-product-handle");
        if (!title || !handle) return;

        var matched = matchedProducts(title, handle, allProducts);
        var existingCount = countSwatchLinks(container);
        var shouldReplace = false;

        if (matched.length > 0) {
            if (isCollectionCard) {
                shouldReplace = matched.length > existingCount;
            } else if (matched.length >= existingCount) {
                shouldReplace = true;
            }
        }

        if (shouldReplace) {
            container.innerHTML = buildSwatchHtml(matched, handle, isCollectionCard);
        }

        if (shouldReplace || existingCount > 0 || (allProducts.length > 0 && matched.length === 0)) {
            container.setAttribute("data-swatches-initialized", "true");
        }
    }

    function observeNewCollectionContainers(allProducts) {
        if (!window.MutationObserver) return;

        var lists = document.querySelectorAll(".product-list, .products-grid-section, .filters-results");
        if (!lists.length) return;

        var observer = new MutationObserver(function (mutations) {
            for (var i = 0; i < mutations.length; i++) {
                var m = mutations[i];
                for (var j = 0; j < m.addedNodes.length; j++) {
                    var node = m.addedNodes[j];
                    if (!(node instanceof HTMLElement)) continue;
                    var containers = node.matches && node.matches(".color-custom-rock")
                        ? [node]
                        : node.querySelectorAll
                        ? node.querySelectorAll(".color-custom-rock")
                        : [];
                    for (var k = 0; k < containers.length; k++) {
                        var el = containers[k];
                        if (el.getAttribute("data-swatches-initialized") === "true") continue;
                        if (el.closest && el.closest(".product-item-swatch-inner")) {
                            displaySwatches(el, allProducts, true);
                        }
                    }
                }
            }
        });

        for (var i = 0; i < lists.length; i++) {
            observer.observe(lists[i], { childList: true, subtree: true });
        }
    }

    function applyAllProducts(allProducts) {
        cachedAllProducts = allProducts;
        var productPageEl = getProductPageContainer();
        var collectionEls = getCollectionContainers();

        if (productPageEl) {
            displaySwatches(productPageEl, allProducts, false);
        }

        for (var i = 0; i < collectionEls.length; i++) {
            displaySwatches(collectionEls[i], allProducts, true);
        }

        if (collectionEls.length > 0) {
            observeNewCollectionContainers(allProducts);
        }
    }

    function run() {
        var productPageEl = getProductPageContainer();
        var collectionEls = getCollectionContainers();
        if (!productPageEl && !collectionEls.length) return;

        fetchAllProducts().then(function (allProducts) {
            if (allProducts.length > 0) {
                applyAllProducts(allProducts);
            }
        });
    }

    function init() {
        run();
        setTimeout(run, 1000);
        setTimeout(run, 3000);
    }

    window.rtColorSwatchesRefresh = function () {
        cachedAllProducts = null;
        var collectionEls = getCollectionContainers();
        for (var i = 0; i < collectionEls.length; i++) {
            collectionEls[i].removeAttribute("data-swatches-initialized");
        }
        var productPageEl = getProductPageContainer();
        if (productPageEl) {
            productPageEl.removeAttribute("data-swatches-initialized");
        }
        run();
    };

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", init);
    } else {
        init();
    }
})();
